const securityDict = {
    "xss-trip-1": "Finding my First Live XSS Bug",
    "race-conditions": "Race Conditions",
    "web-security-notes-from-natas": "Web Security Notes from Natas Wargame",
    "xor-encryption": "XOR Encryption",
}

export default securityDict;